export default __webpack_public_path__ + "static/DSC_0245-b0d0321b6c130aa10f0b031299c0f593.jpg";